import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./rotas/rotas.js";
import { ProvedorDeSessao } from "./shell/Sessao.js";
import { Planos } from "./telas/Planos.js";
import "./estilos.css";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (tentativa, erro) => {
        const status = (erro as { data?: { httpStatus?: number } })?.data?.httpStatus;
        if (status && status >= 400 && status < 500) return false;
        return tentativa < 3;
      },
      retryDelay: (t) => Math.min(1000 * 2 ** t, 30_000),
    },
  },
});

/**
 * `/planos` é PÚBLICA: é para onde o botão do CRM manda quem ainda não tem o
 * produto. Ela fica fora do provedor de sessão porque quem chega ali não tem
 * conta, e o provedor mandaria a pessoa para o login, que é a porta que não abre.
 */
const raiz = document.getElementById("raiz");
if (raiz) {
  const publica = window.location.pathname === "/planos";
  createRoot(raiz).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {publica ? <Planos /> : (
          <ProvedorDeSessao>
            <RouterProvider router={router} />
          </ProvedorDeSessao>
        )}
      </QueryClientProvider>
    </StrictMode>,
  );
}
